/**
 * Main bootstrap module.
 * Loads base dependencies, sets system env variables.
 */
import 'babel-polyfill'
import moment from 'moment'
import 'jquery-ui'
import 'utils/jquery/ui/i18n/jquery.ui.datepicker-ru.min'
import './Promise'
import * as errors from './errors'
import 'utils/date'
import 'utils/date.format'
import 'utils/sprintf'
import 'utils/jquery/jquery.dynatree'
import 'utils/jquery/jquery-ui-timepicker-addon'
import 'utils/jquery/jquery-ui-timepicker-ru'
import './Core'
import './Enums'
import './Util'
import './Xhr'
import './Globals'

console.log('set global env variables')

moment.locale('ru')
Object.assign(global, errors)

Xhr.initialize()
